import { render, staticRenderFns } from "./BrazilTextField.vue?vue&type=template&id=f70427fe&scoped=true&"
import script from "./BrazilTextField.vue?vue&type=script&lang=js&"
export * from "./BrazilTextField.vue?vue&type=script&lang=js&"
import style0 from "./BrazilTextField.vue?vue&type=style&index=0&id=f70427fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70427fe",
  null
  
)

export default component.exports